// extracted by mini-css-extract-plugin
export default {"userNotFound":"UserNotFound_userNotFound__wiK+j","addInfo":"UserNotFound_addInfo__V6bN8"};